import styled from 'styled-components';
import { colors } from "../../../utils/colors";

export const BackBtn = styled.button`
    background: none;
    border: none;
    color: ${colors.CREAM};
    display: flex;
    align-items: center;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    text-transform: uppercase;
    font-size: 21px;

    @media (max-width: 800px) {
        top: ${(prop) => prop.userPanel ? '-10px' : '-20px'};;
        left: 5px;
        font-size: 18px;
    }

    @media (min-width: 550px) {
        cursor: pointer;
    }
`;
